<template>
  <div>
    <h3>National Memberships Report</h3>
    <el-row :gutter="30" type="flex" align="middle">
      <el-col :span="18">
        <span class="description">
          Returns all member and membership type registration details within the current organization.
        </span>
      </el-col>
      <el-col :span="6" class="d-flex flex-justify-end">
        <!-- <el-button type="primary" icon="el-icon-download" @click="sendReport()">Download</el-button> -->
        <el-button type="primary" icon="el-icon-download" @click="sendReportLambda">Download</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-form
      label-position="top"
      :model="filters"
      :rules="filterRules"
      ref="filters"
      class="login-form"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="dateType">
            <el-radio-group v-model="filters.dateType" @change="setSelectedDateType">
              <el-radio
                v-for="s in dateTypes"
                :key="s.value"
                :label="s.value"
              >{{ s.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="filters.dateType==='season'">
        <el-col :span="8">
          <el-form-item prop="season" label="Season">
            <el-select v-model="filters.season" style="width: 100%">
              <el-option
                v-for="s in seasons"
                :key="s.value"
                :label="s.value"
                :value="s.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-else-if="filters.dateType==='date-range'">
        <el-col :span="16">
          <el-form-item
            prop="dates"
            label="Date Range"
          >
            <el-date-picker
              type="daterange"
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              v-model="filters.dates"
              placeholder=""
              value-format="timestamp"
              :format="timedateObj().formDateFormat"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item prop="activeStatus" label="Active Status">
            <el-select v-model="filters.activeStatus" placeholder="Status" >
              <el-option v-for="e in activeStatuses" :label="e.name" :key="e.value" :value="e.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item prop="tags" label="Tags">
            <el-select v-model="filters.tags" placeholder="Tags" multiple>
              <el-option v-for="e in tags" :label="e.label" :key="e.value" :value="e.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item prop="withMemberDetails">
            <span slot="label">
              Member Details?
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">If you choose to include member details in this report all member form fields will be added to the report.</div>
                <i class="el-icon-info info"/>
              </el-tooltip>
            </span>
            <el-select v-model="filters.withMemberDetails" placeholder="Yes / No">
              <el-option :value="true" label="Yes"></el-option>
              <el-option :value="false" label="No"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item prop="fileType" label="File Type">
            <el-select
              v-model="filters.fileType"
              placeholder="Select a file type"
            >
              <el-option
                v-for="fileType in fileTypes"
                :label="fileType.name"
                :key="fileType.type"
                :value="fileType.type"
                :default="fileType.default"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-col :span="24">
      <h4>Report Fields</h4>
      <div class="field-selector-container">
        <div class="field-list">
            <el-tag
              v-for="field in availableFields"
              :key="field"
              size="small"
              type='primary'
            >
              {{ field }}
            </el-tag>
          </div>
        </div>
      </el-col>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment-timezone';
import { timedate } from '@/utils/timedate';
import { errormsg } from '../../../../utils/constants';

export default {
  data() {
    return {
      filters: {
        fileType: 'csv',
        season: undefined,
        dates: undefined,
        membershipIds: undefined,
        dateType: 'season',
        activeStatus: 'all',
        withMemberDetails: false,
        tags: []
      },
      activeStatuses: [
        { name: 'Active', value: 'active' },
        { name: 'Inactive', value: 'inactive' },
        { name: 'All', value: 'all' }
      ],
      filterRules: {
        fileType: {
          required: true,
          message: errormsg.select_option,
          trigger: 'blur',
        },
        dateType: {
          required: true,
          message: errormsg.select_option,
          trigger: 'blur',
        }
      },
      fileTypes: [
        { name: 'CSV', type: 'csv', default: true }
      ],
      dateTypes: [
        { label: 'Season', value: 'season' },
        { label: 'Date Range', value: 'date-range' }
      ],
      tags: [],
      availableFields: [
        'Member Id',
        'Family Name',
        'Given Name',
        'Gender',
        'Club Member',
        'Address',
        'Suburb',
        'State',
        'Post Code',
        'Date of Birth',
        'Email Address',
        'Telephone',
        'Membership Level',
        'Manually Added',
      ]
    };
  },
  async mounted() {
    this.$store.commit('loading', true);
    this.filters.season = this.currentSeason;
    const memberships = await this.$http.get('/assemble/api/v1/admin/memberships');
    const tags = await this.$http.get('/assemble/api/v1/admin/tags');
    this.memberships = memberships.data.data;
    let tagsData = tags.data.data;
    tagsData = this.reducedTagsData(tagsData);
    this.tags = [...this.tags, ...tagsData];
    this.$store.commit('loading', false);
  },
  computed: {
    nationalId() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    currentSeason() {
      return 'All';
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    },
    seasons() {
      const dbSeasons = this.$store.getters['season/seasons'];
      const cloneSeasons = _.cloneDeep(dbSeasons);
      cloneSeasons.unshift({ currentSeason: false, value: 'All' });

      return cloneSeasons;
    },
  },
  methods: {
    timedateObj() {
      return timedate;
    },
    reducedTagsData(tagsData) {
      return _.reduce(tagsData, (tags, tag) => {
        tags.push({ value: tag._id, label: tag.name });
        return _.orderBy(tags, ['label'], 'asc');
      }, []);
    },
    setSelectedDateType() {
      if (this.filters.dateType === 'date-range') this.filters.season = undefined;
      else this.filters.dates = undefined;
    },
    // sendReport() {
    //   this.$refs.filters.validate((valid) => {
    //     if (valid) {
    //       this.$store.commit('loading', true);
    //       const body = {
    //         reportType: 'national-regos',
    //         fileType: this.filters.fileType,
    //         filters: {
    //           season: this.filters.season,
    //           fromDate: _.get(this.filters, 'dates[0]'),
    //           toDate: _.get(this.filters, 'dates[1]'),
    //           dateType: this.filters.dateType,
    //           tagIds: this.filters.tags
    //         },
    //         meta: {
    //           timezone: moment.tz.guess(),
    //         }
    //       };
    //       const url = '/assemble/api/v1/admin/reports';
    //       this.$http
    //         .post(url, body)
    //         .then((response) => {
    //           this.$store.commit('loading', false);
    //           this.$message(response.data.message);
    //         })
    //         .catch(() => {
    //           this.$store.commit('loading', false);
    //           this.$message.error();
    //         });
    //     } else {
    //       return false;
    //     }
    //     return true;
    //   });
    // },
    sendReportLambda() {
      this.$refs.filters.validate((valid) => {
        if (valid) {
          this.$store.commit('loading', true);
          const body = {
            reportType: 'national-regos',
            fileType: this.filters.fileType,
            filters: {
              season: this.filters.season,
              fromDate: _.get(this.filters, 'dates[0]'),
              toDate: _.get(this.filters, 'dates[1]'),
              dateType: this.filters.dateType,
              tagIds: this.filters.tags,
              activeStatus: this.filters.activeStatus,
              withMemberDetails: this.filters.withMemberDetails
            },
            meta: {
              timezone: this.timezone,
            }
          };
          const url = '/assemble/api/v1/admin/reports-lambda';
          this.$http
            .post(url, body)
            .then((response) => {
              this.$store.commit('loading', false);
              this.$message(response.data.message);
            })
            .catch(() => {
              this.$store.commit('loading', false);
              this.$message.error();
            });
        } else {
          return false;
        }
        return true;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
